<template>
    <div id="ModalListSignatarios" class="modal fade in" style="z-index:10000" data-backdrop="false" role="dialog">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-search"></i> Adicionar Signatários</p>
                    <button type="button" class="close" @click="closeModal()" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <signatario-filter :selected="selected" ref="listSignatario"></signatario-filter>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="float-left btn btn-default" @click="closeModal()"><i
                            class="fa fa-times"></i>
                        {{$t('words.close')}}</button>
                    <button type="button" :disabled="loading" @click="addMany()" class="btn btn-success"><i
                            class="fa fa-plus"></i>
                        {{$t('words.add')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignatarioFilter from '../../../views/grupos-signatario/signatario-filter.vue';
    export default {
        components: {
            SignatarioFilter
        },
        data() {
            return {
                loading: false,
                selected: []
            }
        },
        methods: {
            show() {
                this.selected = [];
                this.$refs.listSignatario.fetchData();
                $('#ModalListSignatarios').modal('toggle');
            },
            addMany() {
                console.log(this.selected);
                if (!this.selected.length) {
                    toastr({
                        title: 'Selecione um signatário para adicionar!',
                        icon: 'warning'
                    });
                    return;
                }
                this.$emit('addSignatarios', {token_tipo: 'E', assinatura_tipo: '1', grupo: {
                    signatarios: this.selected}});
                this.closeModal();
        },
        closeModal() {
            $('#ModalListSignatarios').modal('hide');
        },
        validateUser() {
            if (this.request.signatarios.findIndex(
                    x => x.assinatura_email == this.form.assinatura_email &&
                    x.assinatura_tipo == this.form.assinatura_tipo) > -1) {
                toastr({
                    title: 'E-mail já adicionado para esse tipo de assinatura!',
                    icon: 'warning'
                });
                throw 'E-mail já adicionado';
            }
        },
        }
    }
</script>